import classNames from "classnames";
import React from "react";
import { Text } from "..";
import styles from "./field.module.scss";

const Field = ({
  children,
  childrenClassName,
  labelClassName,
  label,
  horizontal,
  className,
  message,
  error,
  labelPosition,
  subLabel,
  style,
  childrenStyle,
  labelStyle,
}) => {
  return (
    <div
      style={style}
      className={classNames(className, styles.container, {
        [`${styles.horizontal}`]: horizontal,
        [`${styles.labelLeft}`]: labelPosition === "left",
      })}
    >
      {label && (
        <div labelStyle={labelStyle} className={classNames(styles.title, labelClassName)}>
          <Text label>{label}</Text>
          {subLabel && (
            <Text italic subtitle>
              {subLabel}
            </Text>
          )}
        </div>
      )}
      <div style={childrenStyle} className={classNames(styles.formContainer, childrenClassName)}>
        {children}
        {message && (
          <Text
            className={classNames(styles.message, {
              [`${styles.error}`]: error,
            })}
          >
            {message}
          </Text>
        )}
      </div>
    </div>
  );
};

export default Field;
